import { useGeo } from "../contexts/GeoContext";

export const useStateRestriction = () => {
  const geo = useGeo();
  return {
    state: geo?.userState,
    tier: geo?.tier,
    isBlocked: Boolean(geo?.isBlocked),
    isSCBlocked: Boolean(geo?.isSCBlocked),
    reason: geo?.blockReason || null,
    loading: Boolean(geo?.loading),
  };
};

export default useStateRestriction;
